import { useRef as w, useState as m, useMemo as z, useCallback as C, useEffect as f } from "react";
import { mergeDeep as b } from "../../../services/utils/index.js";
import { lazyImportQuill as j } from "../lazyImportQuill.js";
const g = "snow", h = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ size: ["small", !1, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, !1] }],
    ["link", "image", "video"],
    [{ color: [] }, { background: [] }],
    ["clean"]
  ],
  clipboard: {
    matchVisual: !1
  }
}, p = [
  "bold",
  "italic",
  "underline",
  "strike",
  "align",
  "list",
  "indent",
  "size",
  "header",
  "link",
  "image",
  "video",
  "color",
  "background",
  "clean"
], R = (o = { theme: g, modules: h, formats: p }) => {
  const r = w(null), [t, k] = m(null), [O, Q] = m({
    quill: void 0,
    quillRef: r
  }), d = z(() => JSON.stringify(o || {}), [o]), u = C(() => {
    var n, a;
    if (!(t != null && t.QuillClass) || !r.current)
      return;
    const e = JSON.parse(d), c = b(e, {
      modules: b(
        h,
        e.modules || {},
        ((n = t.extensionObject) == null ? void 0 : n.modules) || {}
      ),
      formats: e.formats || [
        ...p,
        ...((a = t.extensionObject) == null ? void 0 : a.formats) || []
      ],
      theme: e.theme || g
    }), i = new t.QuillClass(r.current, c);
    o.defaultValue && i.clipboard.dangerouslyPasteHTML(o.defaultValue), Q((s) => ({
      ...s,
      quill: i
    }));
  }, [t, d]);
  return f(() => {
    j().then((e) => {
      var i;
      const c = (i = o.extensions) == null ? void 0 : i.reduce(
        (n, a) => {
          const s = { ...n }, l = a(e.default);
          return l != null && l.modules && (s.modules = { ...s.modules, ...l.modules }), l != null && l.format && s.formats.push(l.format), s;
        },
        { modules: {}, formats: [] }
      );
      k(() => ({ QuillClass: e.default, extensionObject: c })), window.quill = e.default;
    });
  }, []), f(() => {
    u();
  }, [u]), { ...O, init: u };
};
export {
  p as formats,
  h as modules,
  g as theme,
  R as useQuill
};
